export const formatArrayForSelectInput = (arrData, display, isNullable = false) => {
    let arrayToDisplay = [];
    arrayToDisplay = arrData.map((obj, i) => {
        const objToDisplay = {
            value: obj.id,
            display: display.includes("~") ? obj[display.split("~")[0]] + ", " + obj[display.split("~")[1]] : obj[display]
        }
        return objToDisplay;
    });
    if (isNullable) {
        arrayToDisplay.unshift({
            value: null,
            display: ''
        })
    }
    return arrayToDisplay;
}